import {ProcessEngineerAreaDashboard} from '@features/process-engineer-dashboard'
import {useRouteSegmentsAreaNavigation} from '@widgets/area-dashboard'

import {LocationBreadcrumbs} from '../../components'
import {useHrocMapMarkersData} from '../../hooks'
import {AREA_ROUTE_SEGMENTS, PROCESS_ENGINEER_DASHBOARD} from '../../routing'

export const AreaProcessEngineerDashboard = () => (
  <ProcessEngineerAreaDashboard
    dashboardRoute={PROCESS_ENGINEER_DASHBOARD}
    navigation={useRouteSegmentsAreaNavigation(AREA_ROUTE_SEGMENTS)}
    fallbackBreadcrumbs={<LocationBreadcrumbs sx={{ml: 0}} />}
    useMapMarkersDataHook={useHrocMapMarkersData}
  />
)
